(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ClosingContractReasonDialogController', ClosingContractReasonDialogController);

    ClosingContractReasonDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ClosingContractReason'];

    function ClosingContractReasonDialogController ($scope, $stateParams, $uibModalInstance, entity, ClosingContractReason) {
        var vm = this;
        vm.closingContractReason = entity;
        vm.load = function(id) {
            ClosingContractReason.get({id : id}, function(result) {
                vm.closingContractReason = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:closingContractReasonUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.closingContractReason.id !== null) {
                ClosingContractReason.update(vm.closingContractReason, onSaveSuccess, onSaveError);
            } else {
                ClosingContractReason.save(vm.closingContractReason, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
